import { render } from "./CardRateList.vue?vue&type=template&id=87d02f4a"
import script from "./CardRateList.vue?vue&type=script&lang=js"
export * from "./CardRateList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__